import {IDLE} from "../../common/statuses";

export const initialState = {
    status: IDLE,
    error: null,
    // retrievalStatus: undefined,
    current: undefined,
    updateUser: {
        status: IDLE,
        errors: undefined,
    }
}

export const initialAdminState = {
    ...initialState,

    getTeachers: {
        data: undefined,
        status: IDLE,
    },
    teacher: {
        saveImageStatus: IDLE,
        saveStatus: IDLE,
        error: undefined,
    },
    getStudents: {
        data: undefined,
        status: IDLE,
    },
    student: {
        changeBalanceStatus: IDLE,
        error: undefined,
    },
    courses: {
        list: undefined,
        status: IDLE,
    },
    statistic: {
        data: undefined,
        status: IDLE,
    }
}